import { render, staticRenderFns } from "./UserAccountTable.vue?vue&type=template&id=4940fdc2&scoped=true&"
import script from "./UserAccountTable.vue?vue&type=script&lang=js&"
export * from "./UserAccountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940fdc2",
  null
  
)

export default component.exports